import { render, staticRenderFns } from "./CalendarWidget.vue?vue&type=template&id=71703e67&scoped=true"
import script from "./CalendarWidget.vue?vue&type=script&lang=js"
export * from "./CalendarWidget.vue?vue&type=script&lang=js"
import style0 from "./CalendarWidget.vue?vue&type=style&index=0&id=71703e67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71703e67",
  null
  
)

export default component.exports